import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, isEqual, some } from "lodash";
import { v4 as uuid } from "uuid";

import Grid from '@mui/material/Unstable_Grid2';
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

import { HOCList as List } from "../../common/components/List";
import { Placeholder } from "../../common/components/Placeholder";
import { ActionsGroup } from "../../common/components/ActionsGroup";

import { MachineDetail } from "./MachineDetail";
import { MachineEditor } from "./MachineEditor";
import { useDeleteMachineMutation, useGetMachinesQuery, usePostMachineMutation, usePutMachineMutation } from "./machinesAPI";
import {
  setMachine,
  selectEditorErrors,
  selectCurrentMachine,
  selectPristineMachine
} from "./machinesSlice";

const newMachine = {
  id: uuid(),
  title: "",
  model: "",
  dsn: "",
  country: "IT",
  content: { feature_key1: "feature_value1"/*,imageUrl: ''*/ },
  ela: false
};

export const Machines = ({ handleSlide }) => {
  const dispatch = useDispatch();

  const [mode, setMode] = useState('');
  
  const editorErrors = useSelector(selectEditorErrors);
  const selectedMachine = useSelector(selectCurrentMachine);
  const pristineMachine = useSelector(selectPristineMachine);

  const { data = [], isLoading, isFetching } = useGetMachinesQuery();
  const [postMachine, { isLoading: isPosting }] = usePostMachineMutation();
  const [putMachine, { isLoading: isPutting }] = usePutMachineMutation();
  const [deleteMachine, deleteResponse] = useDeleteMachineMutation();

  // Checking to enable save
  const isMachineSelected = !isEmpty(selectedMachine);
  const isSaveEnabled = () => {
    const isPristine = isEqual(pristineMachine, selectedMachine);
    const isValid = isEmpty(editorErrors);
    const { dsn, title, model, country, } = selectedMachine;
    const hasRequireds = !some({ dsn, title, model, country }, isEmpty);

    return !isPristine && isValid && hasRequireds;
  };

  const handleSaveClick = () => {
    // handle creation or editing
    if (mode === "edit") {
      putMachine(selectedMachine);
    }
    if (mode === "create") {
      postMachine(selectedMachine);
    }
  };
  const handleNewClick = () => {
    setMode("create");
    dispatch(setMachine(newMachine));
  }
  const handleCancelClick = () => {
    setMode("");
    dispatch(setMachine({}));
  }
  const handleEditClick = (machine) => {
    setMode("edit")
    dispatch(setMachine(machine))
  }
  const handleDeleteClick = (machine) => {
    deleteMachine(machine);
  };

  const handleTosMappingClick = () => {
    handleSlide("second")
  }
  return (
    <>
        <Grid container direction="row" spacing={1} columns={20}>
          <Grid xs={10} sx={{ display: "flex" }}>
            <List
              isLoading={isLoading || isFetching}
              data={data}
              header="Machines"
              itemType="machine"
              onEditClick={handleEditClick}
              onDeleteClick={handleDeleteClick}
              onNewClick={handleNewClick}
            />
          </Grid>
          <Grid xs={10} sx={{ borderLeft: "1px solid", borderColor: "divider" }} >
            {isMachineSelected && <MachineDetail header="Machine Detail" onMappingsClick={handleTosMappingClick}/>}
            {!isMachineSelected && <Placeholder placeholderText="Select an from the list" height="35vh"/>}
          </Grid>
          <Grid xs={20}>
            <Divider variant="middle" flexItem>
              <ActionsGroup
                loading={isPutting || isPosting}
                generalDisable={!isMachineSelected}
                enableSave={isSaveEnabled()}
                onSaveClick={handleSaveClick}
                onCancelClick={handleCancelClick}
              />
            </Divider>
          </Grid>
          <Grid xs={20}>
            {isMachineSelected && <MachineEditor header="Machine Json Editor" />}
            {!isMachineSelected && <Placeholder placeholderText="Select an from the list" height="35vh" /> }
          </Grid>
        </Grid>
    </>
  );
};
